var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSportGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    width: "120px",
    height: "120px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A03287;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    transform: "translate(-1599.111 -722.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    className: "st0",
    d: "M1801.3,925.7c-2.8,1.3-4.1,5.1-4.4,8c-0.4,3.5,0.8,6.7,2.2,9.9c0.4,1,2.8,0.2,2.4-0.9 c-1-2.9-1.3-6.1-0.9-9.2c0.2-1.3,0.6-2.6,1.1-3.8c0.5-1.1,1.4-2.1,1.7-3.3C1803.8,925.2,1802.1,925.3,1801.3,925.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    className: "st0",
    d: "M1791.8,1001.2c-3.6-0.8-7.2-1.2-10.8-0.1c-1.6,0.5-3.1,1.2-4.5,2.2c-1.2,0.9-2.8,2.2-2.9,3.7 c-0.1,1.1,1.6,0.9,2.2,0.5c1.1-0.7,1.9-1.7,3-2.4c0.9-0.7,2-1.2,3.1-1.6c2.8-0.9,5.8-1.2,8.7-0.7c0.6,0.1,1.3-0.1,1.7-0.6 c0.2-0.3,0.2-0.7-0.1-1C1792.1,1001.3,1791.9,1001.2,1791.8,1001.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    className: "st0",
    d: "M1715.1,800.9c3.6,0.5,7.3,0.5,10.7-0.9c1.5-0.6,2.9-1.4,4.1-2.5c1-0.9,2.6-2.4,2.5-3.9 c0-1.3-1.9-0.8-2.5-0.3c-1,0.8-1.8,1.9-2.8,2.7c-0.8,0.7-1.7,1.3-2.7,1.8c-2.7,1.2-5.7,1.7-8.7,1.4 C1714.6,799,1713.5,800.7,1715.1,800.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    className: "st0",
    d: "M1633,764.8c2.8-1.3,4.1-5.1,4.4-8c0.4-3.5-0.8-6.7-2.2-9.9c-0.5-1-2.8-0.2-2.4,0.9 c1,2.9,1.3,6.1,0.9,9.2c-0.2,1.3-0.6,2.6-1.1,3.8c-0.5,1.1-1.4,2.1-1.7,3.3C1630.6,765.3,1632.2,765.1,1633,764.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    className: "st0",
    d: "M1634.2,901.8c-0.6,1.2-0.7,2.7-1.1,4c-0.4,1.3-1.1,2.6-1.9,3.7c-1.6,2.2-3.7,4-6.1,5.2 c-1.2,0.6-0.3,2,0.9,1.4c3.2-1.5,6.2-3.1,8.4-5.9c1.1-1.3,1.9-2.8,2.5-4.4c0.5-1.5,0.9-3.4,0-4.8 C1636.3,900.1,1634.6,901,1634.2,901.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    className: "st0",
    d: "M1679.5,898.1c-1.3,0.3-2.5,1-3.9,1.3c-1.3,0.3-2.6,0.4-4,0.3c-2.8-0.2-5.6-1.1-8.1-2.5 c-0.9-0.5-2.9,0.8-1.7,1.5c2.8,1.9,5.7,3.4,9.1,3.8c1.7,0.2,3.5,0.1,5.1-0.4c1.6-0.4,3.7-1.1,4.6-2.6 C1681.3,898.5,1680.4,897.9,1679.5,898.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    className: "st0",
    d: "M1690.9,955c-1.4,3.1-2.6,6.4-2.3,9.8c0.2,2.9,1.3,6.8,4.3,7.9c0.9,0.3,2.4-0.5,2.2-1.6 c-0.2-1.2-1.2-2.4-1.7-3.6c-0.6-1.2-0.9-2.6-1.1-3.9c-0.4-2.9-0.1-5.9,0.9-8.6C1693.8,953.8,1691.3,954.1,1690.9,955z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    className: "st0",
    d: "M1753.2,950.3c-2.8,0.7-5.8,0.7-8.6-0.1c-1.1-0.3-2.2-0.8-3.2-1.4c-1.1-0.6-2.1-1.6-3.2-2.1 c-0.7-0.3-2.7,0-2.5,1.2c0.2,1.6,1.6,2.6,2.9,3.4c1.3,0.8,2.8,1.3,4.3,1.6c3.7,0.8,7.4,0,11-1c0.5-0.1,1.1-0.7,0.9-1.2 C1754.5,950.1,1753.7,950.2,1753.2,950.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    className: "st0",
    d: "M1712.8,880.8c2.8-1.9,4.7-4.5,6.4-7.4c0.8-1.3-1.5-1.4-2.1-0.5c-1.5,2.3-3.5,4.3-5.8,5.8 c-1.1,0.7-2.3,1.2-3.6,1.5c-1.4,0.3-2.9,0.3-4.3,0.7c-0.8,0.2-1.6,1.3-0.7,1.9c1.3,1,3.7,0.6,5.2,0.2 C1709.7,882.5,1711.4,881.8,1712.8,880.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    className: "st0",
    d: "M1837,737.4c1.2,0.6,2.6,0.6,3.9,1c1.3,0.4,2.6,1.1,3.8,1.8c2.4,1.6,4.4,3.8,5.9,6.4 c0.5,1,2.8,0.2,2.4-0.9c-1.4-3-2.9-5.8-5.6-7.9c-2.5-1.9-6.5-3.7-9.6-2.4C1837.1,735.7,1835.9,736.8,1837,737.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    className: "st0",
    d: "M1621,992.8c-0.1-2.9,0.6-5.8,1.9-8.4c0.6-1.1-1.8-1.1-2.2-0.3c-1.6,2.9-3.2,5.9-3.4,9.3 c-0.2,2.8,0.4,7.3,3.2,8.6c0.8,0.4,2.6-0.1,2.5-1.2c-0.1-1.4-1-2.6-1.4-3.9C1621.2,995.7,1621,994.3,1621,992.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    className: "st0",
    d: "M1745.3,737.9c3.4,1.2,6.7,2,10.3,1.4c1.7-0.3,3.3-0.9,4.9-1.7c1.2-0.7,3-1.8,3.4-3.3 c0.3-1.3-1.4-1.2-2.1-0.8c-1.1,0.5-2.1,1.4-3.2,2c-1,0.6-2.2,1-3.3,1.2c-2.9,0.5-5.9,0.4-8.7-0.5 C1745.5,735.8,1743.8,737.4,1745.3,737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    className: "st0",
    d: "M1752.1,817.2c1.4,0.3,2.7,0.9,4.1,1c0.7,0.1,2.3-0.7,1.9-1.6c-0.7-1.5-2.7-2-4.2-2.3 c-1.7-0.3-3.4-0.3-5.1-0.1c-3.6,0.5-6.7,2.4-9.6,4.5c-1.2,0.9,0.5,1.7,1.4,1.1c2.4-1.6,5.1-2.6,7.9-2.9 C1749.7,816.8,1750.9,816.9,1752.1,817.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    className: "st0",
    d: "M1734.2,987.2c-0.8,1.1-1.1,2.5-1.8,3.6c-0.6,1.1-1.4,2.1-2.2,3c-2.1,2-4.6,3.4-7.4,4.2 c-1.2,0.3-1.1,2,0.3,1.7c3.5-0.9,6.9-2,9.7-4.5c1.3-1.1,2.3-2.4,3.2-3.9c0.7-1.2,1.5-3,0.9-4.4 C1736.4,985.9,1734.7,986.4,1734.2,987.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    className: "st0",
    d: "M1652.4,782.2c1.4-2.4,3.4-4.4,5.7-5.9c1.1-0.8,2.4-1.3,3.7-1.6c1.3-0.3,2.8-0.3,4.1-0.7 c0.8-0.2,1.6-1.3,0.7-1.9c-1.4-1-3.7-0.5-5.2-0.1c-1.8,0.5-3.5,1.2-5,2.3c-2.8,2-4.6,4.7-6.2,7.7C1649.6,783,1652,783,1652.4,782.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    className: "st0",
    d: "M1832.7,910.7c0.4-0.3,0.5-0.9,0-1.2c-0.6-0.2-1.3-0.1-1.7,0.3c-2.1,1.7-4.6,2.9-7.3,3.5 c-1.2,0.2-2.5,0.3-3.7,0.2c-1.4-0.1-2.7-0.7-4.1-0.7c-0.9,0-2.4,0.8-1.7,1.8c0.9,1.3,3.2,1.6,4.6,1.8c1.7,0.1,3.3,0,4.9-0.4 C1827.2,914.9,1830,913,1832.7,910.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    className: "st0",
    d: "M1775.8,916.7c-3.5,0.9-6.9,2-9.7,4.5c-1.3,1.1-2.3,2.4-3.2,3.9c-0.7,1.2-1.5,3-0.9,4.4 c0.5,1.1,2.2,0.5,2.7-0.2c0.8-1.1,1.1-2.5,1.8-3.6c0.6-1.1,1.4-2.1,2.2-3c2.1-2,4.6-3.4,7.4-4.2 C1777.2,918,1777.2,916.3,1775.8,916.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    className: "st0",
    d: "M1811.4,827.4c-1.7-2.4-2.9-5.1-3.4-8c-0.2-1.4-0.3-2.7-0.1-4.1c0.1-1.3,0.8-2.7,0.7-4 c-0.1-1.2-1.8-0.9-2.5-0.3c-2.5,2.1-2.4,6.3-1.8,9.2c0.7,3.3,2.8,5.9,5,8.4C1810,829.5,1812.1,828.4,1811.4,827.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    className: "st0",
    d: "M1646.7,812.7c1.1-0.7,1.9-1.8,2.9-2.6c0.9-0.7,1.9-1.3,2.9-1.7c2.8-1.1,5.7-1.4,8.7-1 c0.6,0.1,1.3-0.1,1.7-0.6c0.2-0.3,0.2-0.7-0.1-1c-0.1-0.1-0.2-0.1-0.3-0.2c-3.6-0.7-7.2-0.9-10.8,0.3c-1.6,0.5-3.1,1.3-4.4,2.3 c-1.1,0.9-2.7,2.3-2.8,3.8C1644.5,813.2,1646.1,813.1,1646.7,812.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    className: "st0",
    d: "M1654.4,1006c-3.3,0-6.3,3.2-7.9,5.8c-1.8,3.1-2.1,6.5-2.1,10c0,1.2,2.4,0.7,2.4-0.4 c0.2-3,1.2-5.9,2.7-8.5c0.6-1.1,1.4-2,2.3-2.9c1-0.9,2.2-1.5,3.1-2.4C1655.6,1006.9,1655.5,1006,1654.4,1006z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    className: "st0",
    d: "M1701.7,1001.1c-1.3,0.3-2.5,1-3.9,1.3c-1.3,0.3-2.6,0.4-4,0.3c-2.8-0.2-5.6-1.1-8.1-2.5 c-0.9-0.5-2.9,0.8-1.7,1.5c2.8,1.9,5.7,3.4,9.1,3.8c1.7,0.2,3.5,0.1,5.1-0.4c1.6-0.4,3.7-1.1,4.6-2.6 C1703.4,1001.6,1702.6,1001,1701.7,1001.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    className: "st0",
    d: "M1823.2,773.3c-0.5,1.1,1.1,1.2,1.8,1c1.2-0.4,2.3-1.2,3.5-1.6c1.1-0.4,2.3-0.7,3.5-0.7 c2.9-0.1,5.8,0.4,8.5,1.6c0.6,0.2,1.2,0.1,1.7-0.3c0.4-0.3,0.6-1,0-1.2c-3.1-1.6-6.3-3-9.9-2.8c-1.7,0-3.4,0.3-5,0.9 C1825.9,770.8,1823.9,771.7,1823.2,773.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    className: "st0",
    d: "M1819.8,863.3c0.7-1.3,1.6-3,1.1-4.5c-0.4-1.1-2.2-0.5-2.7,0.2c-0.8,1.1-1.1,2.4-1.8,3.6 c-0.6,1.1-1.4,2.1-2.3,3c-2.1,2-4.7,3.4-7.4,4.1c-1.2,0.3-1.1,2,0.3,1.7c3.5-0.8,7-1.9,9.8-4.3C1817.9,866,1819,864.7,1819.8,863.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    className: "st0",
    d: "M1778.7,956.1c2.6,1.2,4.9,2.9,6.7,5.2c0.9,1.1,1.6,2.3,2.2,3.6c0.6,1.3,0.7,2.9,1.5,4 c0.6,0.9,2.3,0.1,2.7-0.7c0.7-1.4,0.2-3.3-0.4-4.7c-0.7-1.5-1.6-2.9-2.8-4.1c-2.3-2.4-5.4-3.7-8.4-4.9 C1779.3,954.1,1777.5,955.6,1778.7,956.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    className: "st0",
    d: "M1849.1,805.2c0-0.6,0.1-1.3,0.2-1.9c0.2-0.7,0.3-1.4,0.3-2.1c-0.2-1.2-1.8-1-2.5-0.3 c-2.5,2.3-2.2,6.4-1.4,9.4c0.9,3.2,3,5.7,5.2,8.1c0.7,0.8,2.9-0.3,2.1-1.2c-1.8-2.3-3-4.9-3.6-7.7 C1849.1,808.1,1849,806.6,1849.1,805.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    className: "st0",
    d: "M1726,898.9c2.8,2,5.5,3.6,8.9,4.1c1.7,0.2,3.4,0.2,5.1-0.2c1.6-0.4,3.8-1,4.7-2.5 c0.6-0.9-0.3-1.5-1.2-1.4c-1.4,0.2-2.6,0.9-3.9,1.1c-1.3,0.3-2.6,0.3-3.9,0.1c-2.8-0.3-5.6-1.3-8-2.8 C1726.8,896.8,1724.8,898.1,1726,898.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    className: "st0",
    d: "M1613.4,829.9c2.9-1.7,5.7-3.7,7.6-6.6c0.9-1.4,1.6-2.9,2-4.4c0.4-1.5,0.7-3.6-0.4-4.9 c-0.7-0.8-2.4-0.1-2.7,0.7c-0.5,1.3-0.4,2.7-0.7,4c-0.3,1.4-0.8,2.7-1.5,3.9c-1.3,2.4-3.2,4.4-5.5,5.9 C1610.9,829.5,1612.3,830.6,1613.4,829.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    className: "st0",
    d: "M1770.3,849.1c-1.2,3,1.6,6.7,3.7,8.6c2.5,2.3,5.6,3.4,8.8,4.4c1,0.3,2.7-1.2,1.3-1.7 c-2.6-1-5-2.6-6.9-4.7c-0.9-1-1.7-2.1-2.3-3.3c-0.6-1.3-0.9-2.9-1.8-4C1772.3,847.6,1770.6,848.3,1770.3,849.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    className: "st0",
    d: "M1841.8,983.3c-1.1-1-2.4-1.8-3.9-2.4c-3.4-1.4-7-1.4-10.6-1.1c-1.1,0.1-1.9,1.9-0.4,1.8 c3-0.1,5.9,0.5,8.6,1.8c1.1,0.6,2.1,1.3,3,2.1c1,0.9,1.8,2.2,3,2.9c0.8,0.5,2.5-0.1,2.5-1.2 C1844.2,985.7,1842.9,984.3,1841.8,983.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    className: "st0",
    d: "M1836.7,949.9c0.8-1.2,1.8-2.9,1.3-4.4c-0.4-1.2-2.2-0.4-2.7,0.2c-0.8,1-1.2,2.3-2,3.3 c-0.7,1-1.5,1.9-2.4,2.7c-2.2,1.8-4.8,3.1-7.6,3.6c-0.5,0.1-1.3,0.5-1.2,1.1s0.7,0.8,1.2,0.7c3.7-0.6,7.2-1.5,10.2-3.8 C1834.7,952.4,1835.8,951.3,1836.7,949.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    className: "st0",
    d: "M1729.9,763c2.9-0.2,5.8,0.3,8.5,1.6c1.1,0.5,2.2,1.2,3.1,2c1,0.9,1.8,2,3,2.7 c0.8,0.5,2.5-0.1,2.5-1.2c0-1.6-1.3-2.9-2.4-3.9c-1.2-1-2.5-1.8-4-2.3c-3.4-1.3-7-1.2-10.6-0.7 C1728.6,761.4,1728.3,763.1,1729.9,763z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    className: "st0",
    d: "M1779.8,744.5c1.6-2.2,3.7-4,6.1-5.3c1.1-0.6,2.3-1,3.5-1.2c1.4-0.3,2.9-0.1,4.2-0.4 c0.6-0.1,2.2-1.1,1.3-1.8c-1.3-1.1-3.5-1-5.1-0.7c-1.8,0.3-3.6,0.9-5.2,1.8c-3,1.6-5.1,4.3-7,7.1 C1776.9,745.3,1779.2,745.4,1779.8,744.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    className: "st0",
    d: "M1645.7,935.1c1.2-0.5,2.3-1.4,3.5-2c1.1-0.5,2.3-0.9,3.6-1.1c2.9-0.4,5.9,0,8.6,1 c0.8,0.3,2.7-1.2,1.5-1.6c-3.3-1.4-6.6-2.4-10.2-2c-1.7,0.2-3.4,0.6-5,1.4c-1.4,0.7-3.3,1.7-3.8,3.3 C1643.6,935.2,1644.9,935.4,1645.7,935.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    className: "st0",
    d: "M1701.5,902c-3,1.1-4.6,4.6-5.3,7.6c-0.8,3.6,0.1,6.9,1.3,10.3c0.4,1.1,2.7,0.2,2.4-0.9 c-0.8-3.1-0.8-6.3,0-9.4c0.3-1.2,0.8-2.4,1.4-3.5c0.6-1.1,1.6-2,2-3.1C1703.6,901.9,1702.2,901.7,1701.5,902z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    className: "st0",
    d: "M1688.5,782.1c1.8,0.1,3.5-1,4.8-2c1.3-1,2.4-2.2,3.3-3.6c1.9-3,2.4-6.3,2.6-9.8 c0.1-1.2-2.3-0.7-2.4,0.4c-0.4,3-1.5,5.9-3.2,8.4c-0.7,1-1.6,1.9-2.5,2.7c-1,0.8-2.3,1.3-3.2,2.2 C1687.1,781.2,1687.4,782.1,1688.5,782.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    className: "st0",
    d: "M1762.3,974.1c-0.6-0.1-1.3,0.1-1.7,0.6c-2,2.6-3.9,5.2-4.6,8.5c-0.6,2.8-0.9,7.5,1.9,9.3 c0.8,0.5,2.5-0.2,2.5-1.2c0.1-1.4-0.6-2.8-0.8-4.1c-0.2-1.5-0.2-2.9,0-4.4c0.4-2.7,1.5-5.3,3.1-7.5c0.2-0.3,0.2-0.7-0.1-1 C1762.6,974.1,1762.5,974.1,1762.3,974.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    className: "st0",
    d: "M1688.7,812.8c1.1-2.7,2.7-5,4.8-6.9c1-0.9,2-1.6,3.2-2.1c1.3-0.6,2.7-0.8,3.9-1.4 c0.5-0.3,1.2-1.4,0.3-1.7c-1.6-0.7-3.6-0.1-5.1,0.5c-1.7,0.7-3.2,1.7-4.6,2.9c-2.5,2.4-3.9,5.4-5,8.7 C1685.9,814,1688.3,813.7,1688.7,812.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    className: "st0",
    d: "M1852.7,860.9c-1.2-0.4-2.7-0.2-4-0.5c-1.4-0.3-2.8-0.8-4.1-1.6c-2.5-1.4-4.6-3.4-6.3-5.7 c-0.6-0.9-2.8,0.2-2.1,1.2c1.7,2.8,3.5,5.4,6.3,7.1c2.8,1.7,7.1,3,10.1,1.3C1853.5,862.2,1853.7,861.2,1852.7,860.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    className: "st0",
    d: "M1657.1,834.1c-2.8,1.7-5.6,3.7-7.4,6.5c-0.9,1.4-1.6,3-2,4.6c-0.3,1.5-0.6,3.5,0.5,4.8 c0.7,0.8,2.4,0.1,2.7-0.7c0.5-1.3,0.4-2.8,0.6-4.2c0.3-1.4,0.8-2.7,1.4-3.9c1.3-2.3,3.1-4.4,5.3-5.9 C1659.7,834.4,1658.3,833.3,1657.1,834.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    className: "st0",
    d: "M1653.7,743.2c2.7-1.2,5.6-1.7,8.6-1.4c1.2,0.1,2.4,0.4,3.5,0.9c1.2,0.5,2.3,1.3,3.6,1.6 c0.8,0.2,2.5-0.5,2.2-1.6c-0.4-1.4-2.1-2.2-3.4-2.7c-1.6-0.6-3.2-1-4.9-1c-3.8-0.2-7.2,1.2-10.5,2.8 C1651.6,742.3,1652.6,743.7,1653.7,743.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    className: "st0",
    d: "M1854.7,912.1c-0.6-3.1-0.4-6.4,0.7-9.4c0.4-1.2,1-2.3,1.7-3.3c0.7-1,1.7-1.9,2.2-3 c0.5-1.1-1.1-1.2-1.8-1c-3,0.9-4.9,4.5-5.7,7.2c-1,3.5-0.3,6.9,0.6,10.3C1852.6,914,1854.9,913.2,1854.7,912.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    className: "st0",
    d: "M1874.1,776.7c-1.7,2.9-3.3,5.9-3.5,9.3c-0.2,2.8,0.3,7.3,3.1,8.7c0.8,0.4,2.6-0.1,2.5-1.2 c-0.1-1.4-0.9-2.6-1.3-3.9c-0.4-1.4-0.6-2.8-0.6-4.2c0-2.9,0.7-5.8,2-8.4C1876.9,775.9,1874.6,776,1874.1,776.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    className: "st0",
    d: "M1645.6,880c2,2.4,3.4,5.3,4,8.4c0.2,1,2.5,0.3,2.4-0.6c-0.5-3.5-1-6.9-3.2-9.8 c-1.8-2.4-4.8-4.9-8-4.5c-0.7,0.1-2.1,1-1.3,1.8c0.8,0.9,2.3,1.4,3.3,2.1C1643.8,878.1,1644.7,879,1645.6,880z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    className: "st0",
    d: "M1803.2,782.1c1.7-0.3,3.3-0.9,4.9-1.7c1.2-0.7,3-1.8,3.4-3.3c0.3-1.3-1.4-1.2-2.1-0.8 c-1.1,0.5-2.1,1.4-3.2,2c-1,0.6-2.2,1-3.3,1.2c-2.9,0.5-5.9,0.4-8.7-0.5c-1-0.3-2.7,1.2-1.3,1.7 C1796.3,781.9,1799.7,782.7,1803.2,782.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    className: "st0",
    d: "M1667.9,961.1c-1.3,0.6-2.4,1.5-3.6,2.1c-1.1,0.5-2.2,0.9-3.4,1c-2.9,0.4-5.9,0.1-8.6-0.8 c-0.9-0.3-2.7,1.2-1.5,1.6c3.3,1.3,6.6,2.3,10.2,1.8c1.7-0.2,3.4-0.7,4.9-1.4c1.4-0.7,3.3-1.8,3.8-3.4 C1670,961.1,1668.7,960.8,1667.9,961.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    className: "st0",
    d: "M1756.3,786.3c-1.2,0.3-1.1,2,0.3,1.7c2.9-0.7,5.9-0.7,8.8,0.1c1.2,0.4,2.3,0.9,3.3,1.5 c1.1,0.7,2,1.7,3.2,2.2c0.7,0.3,2.7,0,2.5-1.2c-0.2-1.6-1.6-2.7-2.9-3.5c-1.3-0.8-2.7-1.4-4.2-1.7 C1763.6,784.6,1759.9,785.3,1756.3,786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    className: "st0",
    d: "M1786.4,887.1c-0.8-0.2-2.6,0.4-2.2,1.6c0.4,1.2,1.6,2,2.3,3c0.8,1.1,1.4,2.3,1.9,3.6 c1,2.9,1.3,6.1,0.9,9.1c-0.2,1.1,2.2,0.7,2.4-0.2c0.8-3.4,1.4-6.8,0.4-10.3C1791.2,891.3,1789.4,887.7,1786.4,887.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    className: "st0",
    d: "M1709.9,747.7c0.8,0.2,2.6-0.5,2.2-1.6c-0.4-1.2-1.5-2.1-2.2-3.1c-0.7-1.1-1.3-2.4-1.8-3.7 c-0.9-3-1.1-6.1-0.5-9.1c0.2-1.1-2.1-0.7-2.4,0.2c-0.9,3.4-1.6,6.8-0.7,10.3C1705.2,743.3,1706.9,747,1709.9,747.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    className: "st0",
    d: "M1866.6,939.7c-1.1,2.7-2.7,5-4.8,6.9c-1,0.9-2,1.6-3.2,2.1c-1.3,0.6-2.7,0.8-3.9,1.4 c-0.5,0.3-1.2,1.4-0.3,1.7c1.6,0.7,3.6,0.1,5.1-0.5c1.7-0.7,3.2-1.7,4.6-2.9c2.5-2.4,3.9-5.4,5-8.7 C1869.3,938.5,1866.9,938.8,1866.6,939.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    className: "st0",
    d: "M1886.1,961c-0.2-1-2.5-0.3-2.4,0.6c0.3,3.1-0.1,6.2-1.3,9.1c-0.5,1.2-1.1,2.3-1.9,3.2 c-0.8,1-1.9,1.8-2.6,2.9c-0.5,0.9,0.3,1.6,1.2,1.4c3.2-0.6,5.6-4.1,6.6-7C1887.1,967.8,1886.7,964.5,1886.1,961z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    className: "st0",
    d: "M1723.8,938.6c-1.3-1.2-3.5-1-5.1-0.9c-1.8,0.2-3.6,0.8-5.2,1.7c-3.1,1.5-5.2,4.1-7.2,6.8 c-0.2,0.3-0.2,0.7,0.1,1c0.1,0.1,0.2,0.1,0.3,0.1c0.6,0.1,1.3-0.1,1.7-0.6c1.7-2.1,3.8-3.8,6.3-5c1.1-0.5,2.3-0.9,3.6-1.1 c1.4-0.2,2.8,0,4.2-0.2C1723.1,940.3,1724.7,939.4,1723.8,938.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    className: "st0",
    d: "M1732.9,843.7c0.9,0.9,1.7,2,2.4,3.1c1.6,2.8,2.4,5.9,2.4,9.1c0,1.2,2.4,0.7,2.4-0.4 c0.2-3.5,0.3-7.1-1.4-10.3c-1.3-2.6-3.6-5.5-6.7-5.7c-0.6,0-2.4,0.7-1.9,1.6C1730.9,842.2,1732.1,842.8,1732.9,843.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    className: "st0",
    d: "M1690.4,855.9c3.7,0.3,7.1-0.8,10.4-2.3c0.4-0.2,1.1-0.6,0.9-1.2c-0.2-0.6-1-0.5-1.5-0.4 c-2.7,1.1-5.7,1.5-8.6,1.1c-1.2-0.2-2.4-0.5-3.5-1c-1.2-0.5-2.3-1.4-3.6-1.8c-0.9-0.3-2.5,0.5-2.2,1.6c0.4,1.4,2.1,2.3,3.3,2.8 C1687.2,855.4,1688.8,855.8,1690.4,855.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    className: "st0",
    d: "M1810.7,732c1-0.9,1.5-2,2.4-3c0.8-0.9,1.7-1.7,2.8-2.3c2.5-1.5,5.3-2.3,8.2-2.4 c0.6,0,1.2-0.3,1.5-0.9c0.2-0.6-0.3-0.9-0.8-0.9c-3.7,0-7.3,0.4-10.6,2.1c-1.5,0.8-2.8,1.8-3.9,3c-0.9,1-2.3,2.6-2.1,4.1 C1808.4,732.9,1810,732.6,1810.7,732z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    className: "st0",
    d: "M1629.5,960.4c-2.7,1.2-5.6,1.8-8.5,1.6c-1.2-0.1-2.4-0.4-3.5-0.8c-1.3-0.5-2.4-1.3-3.7-1.6 c-0.8-0.2-2.6,0.5-2.2,1.6c0.4,1.4,2.2,2.2,3.4,2.7c1.6,0.6,3.2,0.9,4.9,0.9c3.8,0.1,7.2-1.3,10.5-2.9 C1631.7,961.2,1630.7,959.9,1629.5,960.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportGraphic);
export default __webpack_public_path__ + "static/media/sport-graphic.3e6a0e5e71d39b3df0c1e82895688266.svg";
export { ForwardRef as ReactComponent };